import React from 'react'
import Running_preview_comp from '../../components/mobile_view_comp/running_preview_comp/running_preview_com'

export default function Running_preview() {
  return (
    <>
        <Running_preview_comp />
    </>
  )
}